{
  "privacyType": {
    "aboutAriaLabel": "About {{label}}"
  },
  "filters": {
    "title": "Filters",
    "clearAll": "Clear all",
    "apply": "Apply",
    "atmosphere": "Atmosphere",
    "privacyLevel": "Privacy Level",
    "yourLists": "Your Lists",
    "cuisine": "Cuisine",
    "policy": "Policy",
    "budget": "Budget",
    "onlyShowInPolicy": "Only Show In-Policy Options",
    "sortedBy": "Sorted By",
    "anyPolicy": "Any policy",
    "cuisines": "Cuisines",
    "ratings": "Ratings",
    "michelinAwards": "Michelin Awards",
    "lists": "Lists",
    "rating": "Rating",
    "popularIn": "Popular In {{industry}}",
    "openModal": "Filters",
    "reset": "Reset"
  },
  "searchTypeTabs": {
    "venues": "Venues",
    "spaces": "Spaces"
  },
  "sort": {
    "recommended": "Recommended",
    "distance": "Distance",
    "sortByPrefix": "Sort by:",
    "sortedByPrefix": "Sorted By:"
  },
  "budget": {
    "total": "Total",
    "perPerson": "Per Person"
  },
  "ratings": {
    "exceptional45": "Exceptional (4.5+)",
    "veryGood40": "Very Good (4.0+)"
  },
  "awards": {
    "oneStar": "1-Star",
    "twoStar": "2-Star",
    "threeStars": "3-Stars",
    "bibGourmand": "Bib Gourmand",
    "greenStar": "Michelin Green Star",
    "michelinStar": "Michelin Star",
    "michelinOneStarFull": "1 Michelin Star",
    "michelinTwoStarsFull": "2 Michelin Stars",
    "michelinThreeStarsFull": "3 Michelin Stars",
    "aaaFiveDiamonds": "AAA 5 Diamonds",
    "aaaFourDiamonds": "AAA 4 Diamonds",
    "eaterFeature": "Eater Feature",
    "gayotFeature": "Gayot Feature",
    "infatuationFeature": "Infatuation Feature",
    "jamesBeardFoundationMention": "James Beard Foundation Mention",
    "laListeSelection": "La Liste Selection",
    "spiritedAwardsMention": "Spirited Awards Mention",
    "tripAdvisorTravelersChoice": "TripAdvisor Travelers Choice",
    "worlds50BestMention": "Worlds 50 Best Mention",
    "other": "Other"
  },
  "browseReturn": {
    "backToChat": "Back to chat",
    "backToNamed": "Back to {{label}}"
  },
  "roomTypes": {
    "PRIVATE": {
      "label": "Private",
      "badgeLabel": "Fully Private",
      "filterTooltip": "Inquiry-based private room, exclusive to your group."
    },
    "SEMI-PRIVATE": {
      "label": "Semi-Private",
      "badgeLabel": "Semi-Private",
      "filterTooltip": "Inquiry-based space, partially separated or roped off from the main room."
    },
    "SHARED": {
      "label": "Shared space",
      "badgeLabel": "Shared space",
      "filterTooltip": "Inquiry-based seating in the main dining area (not instant-book tables)."
    },
    "GENERAL": {
      "label": "General",
      "badgeLabel": "General"
    },
    "MAIN": {
      "label": "Main Dining",
      "badgeLabel": "Main Dining"
    }
  },
  "expandedRoomHeadings": {
    "GENERAL": "General Dining",
    "SHARED": "Shared Spaces",
    "MAIN": "Main Dining Room",
    "SEMI-PRIVATE": "Semi-Private Spaces",
    "PRIVATE": "Fully Private Spaces"
  },
  "diningTypes": {
    "FINE_DINING": "Fine Dining",
    "UPSCALE_DINING": "Upscale",
    "CASUAL_DINING": "Casual"
  },
  "listTypes": {
    "BOOKED_BY_COWORKERS": "Booked by Coworkers",
    "TRENDING": "Trending"
  },
  "lists": {
    "yourLists": "Your Lists",
    "yourFavorites": "Your Favorites",
    "preferredVenues": "Preferred Venues",
    "industryFavorites": "{{industry}} Favorites",
    "sampleMenu": "Sample Menu",
    "clearYourLists": "Clear Your Lists",
    "popular": "Popular",
    "noListsYet": "No lists yet",
    "noListsHint": "Save a venue or follow a list to get started"
  },
  "favoritesFilter": {
    "removeFilterSubtitle": "Remove the filter to start saving your favorite spots",
    "clearFilter": "Clear Filter"
  },
  "search": {
    "placeholderByName": "Search by name",
    "placeholderNameOrCuisine": "Search by name or cuisine"
  },
  "carousel": {
    "previousPhoto": "Previous photo",
    "nextPhoto": "Next photo"
  },
  "keywordChip": {
    "clearSearchTerm": "Clear search term {{term}}"
  },
  "compactCard": {
    "viewVenue": "View {{name}}",
    "removeFromFavorites": "Remove {{name}} from favorites",
    "favoriteVenue": "Favorite {{name}}",
    "removeFromShortlist": "Remove {{name}} from shortlist",
    "shortlistVenue": "Shortlist {{name}}"
  },
  "roomGroup": {
    "alaCarte": "À la Carte",
    "prixFixeMenu": "Prix Fixe Menu",
    "mainDiningSpendRange": "{{symbol}}30-100pp"
  },
  "nextAvailability": {
    "outOfPolicy": "Out of Policy",
    "policyWarningMinSpend": "You are seeing this warning because the minimum spend plus estimated taxes, fees and required gratuity is over your {{symbol}}{{limit}} pp limit.",
    "policyWarningSelection": "You are seeing this warning because the required food & beverage selection plus estimated taxes, fees and required gratuity is over your {{symbol}}{{limit}} pp limit.",
    "previousWeek": "Previous week",
    "nextWeek": "Next week",
    "selectDatePrompt": "Select a date to see availability",
    "noOnlineAvailability": "At the moment, there's no online availability for {{date}} within 2 hours of {{time}}.",
    "loadingAvailability": "Loading availability...",
    "timeslotTakenBody": "This time slot was just taken, but we'd love to help you find other options.",
    "exploreOtherOptions": "Explore other options",
    "findNextAvailableTime": "Find Next Available Time",
    "minSpendSuffix": "{{amount}} min",
    "modalTitleWithDate": "{{date}} @ {{time}}",
    "nextAvailabilityForGuestsOnDate": "The next availability for {{guestLabel}} is <dateButton>{{date}}.</dateButton>",
    "limitedResultsResetEventType_one": "Limited results for the {{eventType}} Event Type. <resetLink>Reset Event Type</resetLink> to see {{count}} more option.",
    "limitedResultsResetEventType_other": "Limited results for the {{eventType}} Event Type. <resetLink>Reset Event Type</resetLink> to see {{count}} more options."
  },
  "explore": {
    "prefixExplore": "Explore",
    "prefixNear": "Near",
    "labelVenues": "venues",
    "labelLocation": "Location"
  },
  "criteria": {
    "legendAvailabilityCriteria": "Availability criteria",
    "filterByEvent": "Filter by event",
    "date": "Date",
    "time": "Time",
    "partySize": "Party Size",
    "clearEvent": "Clear event",
    "clearDate": "Clear date",
    "clearTime": "Clear time",
    "clearPartySize": "Clear party size",
    "anyEvent": "Any event",
    "eventAria": "Event",
    "filterByEventTitle": "Filter by event",
    "partyGuests_one": "{{count}} guest",
    "partyGuests_other": "{{count}} guests"
  },
  "zeroState": {
    "noMatchesTitle": "It looks like we don't have any matches for your search.",
    "tryRemovingFilters": "Try removing some of your filters.",
    "inquireAvailability": "Inquire for Availability",
    "clearAllFilters": "Clear All Filters",
    "noVenuesTitle": "No venues found",
    "noVenuesBody": "Try another search, adjust party size and date, or zoom out",
    "noVenuesAiBody": "Try another search, adjust party size and date, or ask Ande for help",
    "askAnde": "Ask Ande"
  },
  "concierge": {
    "needHelpTitle": "Need help finding a venue?",
    "needHelpSubtitle": "Let us help",
    "contactTeam": "Contact our Team",
    "contactConcierge": "Contact Concierge"
  },
  "refreshModal": {
    "oops": "Oops!",
    "timedOut": "Looks like your results have timed out.",
    "pleaseRefresh": "Please refresh the page",
    "refresh": "Refresh"
  },
  "shortlist": {
    "addToShortlist": "Add to Shortlist",
    "addToEventAria": "Add to Event Shortlist",
    "removeFromEventAria": "Remove from Event Shortlist",
    "title": "Shortlist",
    "yourShortlist": "Your Shortlist",
    "emptyTitle": "No venues shortlisted yet.",
    "emptyHint": "Click the + icon on any venue to add it here.",
    "inquired": "Inquired",
    "remove": "Remove",
    "viewEvent": "View Event",
    "addedToShortlist": "Added to Shortlist",
    "removeFromShortlist": "Remove from Shortlist"
  },
  "saveToEvent": {
    "title": "Save to an Event",
    "postTitle": "Save your shortlist selections to an event.",
    "linkToEvent": "Link to an event",
    "addedToExistingHint": "The venue will be added to this event.",
    "createNewHint": "Once submitted, a new event will be created for this shortlist.",
    "noLocationSet": "No location set",
    "selectGuests": "Select guests",
    "guestOption_one": "{{count}} Guest",
    "guestOption_other": "{{count}} Guests",
    "adding": "Adding...",
    "addToEvent": "Add to Event",
    "date": "Date",
    "startTime": "Start Time",
    "location": "Location",
    "guestCount": "Guest Count"
  },
  "eventPicker": {
    "addToEvent": "Add to Event",
    "createNewEvent": "Create New Event",
    "noEventsHint": "You have no events to add this venue to.",
    "failedAdd": "Failed to add to event",
    "failedRemove": "Failed to remove from event"
  },
  "addToEventPopover": {
    "removeFromCompare": "Remove from Compare"
  },
  "policyBanner": {
    "why": "Why?",
    "pointsAway_one": "Just {{count}} point away!",
    "pointsAway_other": "Just {{count}} points away!",
    "earnGiftCard": "Complete a reservation and earn a {{amount}} gift card.",
    "policyPerPerson": "Policy is {{amount}} per person"
  },
  "verifiedMatches": {
    "title": "No verified matches",
    "bodySearch": "None of our venues with full details match your search.",
    "bodyGroup": "None of our venues with full details match your group."
  },
  "browseAiHeader": {
    "exitEvent": "Exit Event",
    "clear": "Clear",
    "selectDate": "Select date",
    "selectEventType": "Select event type",
    "selectPartySize": "Select party size"
  },
  "onboardingModal": {
    "completeAccountDetails": "Complete your Account Details"
  },
  "listings": {
    "search": "Search",
    "hideMap": "Hide Map",
    "showMap": "Show Map",
    "aboutListing": "About {{name}}",
    "averagePrice": "Average Price:",
    "minSpend": "Min. Spend:",
    "priceIncludes": "Price Includes:",
    "inquired": "Inquired",
    "inquiryBadgeAlt": "Inquiry Badge",
    "duration": "Duration",
    "clearDuration": "Clear Duration",
    "serviceLevel": "Service Level",
    "budgetSection": "Budget",
    "ratingSection": "Rating",
    "serviceLevelSection": "Service Level",
    "dietaryRestrictionsSupported": "Dietary Restrictions Supported",
    "durationSection": "Duration",
    "budgetUsd": "Budget (USD)",
    "budgetAfterTaxesHint": "After taxes, fees & gratuity.",
    "budgetAny": "Any",
    "concierge": {
      "needHelpDining": "Need help finding a venue?",
      "needHelpCatering": "Need help finding catering?",
      "needHelpActivity": "Need help finding an activity?",
      "needHelpListing": "Need help finding a listing?",
      "zeroState": {
        "diningTitle": "Dining is not live in this area yet",
        "diningBody": "Reach out to our team to plan your dining experience.",
        "cateringTitle": "Catering is coming to this area soon",
        "comingSoonBody": "Until then, our team has you covered. Submit a request and we'll handle the rest.",
        "inOfficeTitle": "Office experiences are coming to this area soon",
        "outOfOfficeTitle": "Team activities are coming to this area soon",
        "defaultTitle": "This listing type is not live in this area yet",
        "defaultBody": "Reach out to our team and we can help plan it for you."
      }
    },
    "filters": {
      "cateringFormat": "Catering Format",
      "mealType": "Meal Type",
      "beverageService": "Beverage Service",
      "activityFormat": "Activity Format",
      "noiseLevel": "Noise Level",
      "privacyLevel": "Privacy Level"
    },
    "filterOptions": {
      "cateringFormat": {
        "BOXED": "Boxed",
        "BUFFET": "Buffet",
        "PASSED": "Passed",
        "PLATED": "Plated"
      },
      "mealType": {
        "BREAKFAST": "Breakfast",
        "BRUNCH": "Brunch",
        "LUNCH": "Lunch",
        "DINNER": "Dinner",
        "HAPPY_HOUR": "Happy Hour"
      },
      "beverage": {
        "BEVERAGES": "Beverages",
        "ALCOHOL": "Alcohol"
      },
      "noiseLevel": {
        "QUIET": "Quiet",
        "MODERATE": "Moderate",
        "LOUD": "Loud",
        "VERY_LOUD": "Very Loud"
      },
      "privacyLevel": {
        "SHARED_SPACE": "Shared Space",
        "SEMI_PRIVATE": "Semi Private",
        "FULLY_PRIVATE": "Fully Private",
        "ENTIRE_VENUE": "Entire Venue"
      },
      "cateringServiceLevel": {
        "FULL_SERVICE": "Full Service",
        "DROP_OFF_AND_SETUP": "Drop Off & Setup",
        "DROP_OFF": "Drop Off"
      },
      "activityFormat": {
        "WORKSHOP": "Workshop",
        "FOOD_TRUCK": "Food Truck",
        "WINE_TASTING": "Wine Tasting",
        "DINING_CLASS": "Dining Class",
        "COCKTAIL_CLASS": "Cocktail Class"
      }
    },
    "averagePricePerPerson": "{{amount}} pp",
    "filterPills": {
      "cateringFormat": "Format",
      "beverageService": "Beverages",
      "privacyLevel": "Privacy"
    }
  },
  "policiesModal": {
    "title": "Learn more about your organization's policies",
    "ok": "Ok",
    "intro": "Your organization's policy dictates the food & beverage allowance per person, including all taxes, fees and required gratuity.",
    "warningTitle": "Out of Policy Risk Warning",
    "warningIntro": "You are seeing this warning because one or more of these conditions apply:",
    "warningItem1": "There is a minimum spend that, including taxes, fees, and required gratuity is over your policy limit.",
    "warningItem2": "The space's required food & beverage selection plus taxes, fees and required gratuity is over your policy limit.",
    "warningItem3": "The average a-la-carte spend in this venue is over your policy limit.",
    "footerNote": "All total spend estimations take into consideration taxes, fees and required gratuity."
  },
  "pdr": {
    "aboutThisSpace": "About this Space",
    "aboutThisSpaceLower": "About this space",
    "minimumSpend": "Minimum Spend",
    "adminFee": "Admin Fee",
    "serviceCharge": "Service Charge",
    "taxesFeesGratuity": "Taxes, fees, and gratuity",
    "pricingReachOut": "Reach out to our team to confirm exact pricing.",
    "pricingOnRequest": "Pricing on a request basis. Submit a request with the venue to confirm exact pricing.",
    "policyEventTypeWithAllowance": "{{amount}} pp - {{name}}",
    "seatedCapacity": "Seated Capacity",
    "standingCapacity": "Standing Capacity",
    "spaceSize": "Space Size",
    "maxStanding_one": "Max {{count}} standing",
    "maxStanding_other": "Max {{count}} standing",
    "sqft_one": "{{count}} sqft",
    "sqft_other": "{{count}} sqft",
    "outOfPolicySuffix": " (Out of Policy)",
    "seeMore": "See More",
    "moreDetails": "More Details",
    "estimatedTotal": "Estimated Total",
    "priceOnRequest": "Price on request",
    "averageCheckSize": "Average Check Size",
    "estimatedSpend": "Estimated Spend",
    "startingMinSpend": "Starting {{amount}}",
    "forPartyGuests_one": "(for {{count}} guest)",
    "forPartyGuests_other": "(for {{count}} guests)",
    "menuStartsAt": "Menu Starts At",
    "estimatedDepositDue": "Estimated Deposit Due"
  },
  "menuModal": {
    "menuItemDetails": "Menu Item Details",
    "sampleMenu": "Sample Menu",
    "unnamedItem": "Unnamed Item",
    "menuItem": "Menu Item",
    "uncategorized": "Uncategorized",
    "noDescriptionAvailable": "No description available",
    "noMenuSelectionsAvailable": "No menu selections available.",
    "viewMore": "View More",
    "pricePerPerson": "{{amount}} pp",
    "priceEach": "{{amount}} each"
  },
  "availability": {
    "notAvailable": "Not Available",
    "unknownInquire": "Unknown availability. Inquire to confirm.",
    "inquireForAvailability": "Inquire for Availability",
    "nextAvailable": "Next Available",
    "noMinimum": "No Minimum",
    "bookNow": "Book Now",
    "inquire": "Inquire",
    "requesting": "Requesting...",
    "reserving": "Reserving...",
    "mainDining": "Main Dining",
    "largeGroup": "Large Group",
    "guestCount_one": "{{count}} Guest",
    "guestCount_other": "{{count}} Guests",
    "requested": "Requested"
  },
  "badges": {
    "comingSoon": "Coming Soon",
    "preferred": "Preferred",
    "trending": "Trending",
    "bookedByCoworkers": "Booked by coworkers",
    "trendingTooltip": "Recently featured in Infatuation, Eater or other publications as a hotspot.",
    "outOfPolicyRisk": "Out of policy risk",
    "bookedByCoworkersTitle_one": "Booked by {{count}} coworker",
    "bookedByCoworkersTitle_other": "Booked by {{count}} coworkers",
    "bookedByCoworkersTitleMax": "Booked by 10+ coworkers",
    "featuredByTastemakersTitle_one": "Booked by {{count}} tastemaker",
    "featuredByTastemakersTitle_other": "Booked by {{count}} tastemakers",
    "featuredByTastemakersTitleMax": "Booked by 10+ tastemakers"
  },
  "toasts": {
    "addedToEvent": "Added to event",
    "removedFromEvent": "Removed from event"
  },
  "benefits": {
    "upToPercentOffBill": "Up to {{reduction}}% off your bill",
    "upToPercentOffFees": "Up to {{reduction}}% off of fees",
    "waived": {
      "ROOM_FEE": "Waived room fee",
      "ADMIN_FEE": "Waived admin fee",
      "CANCELLATION_FEE": "Waived cancellation fee",
      "MINIMUM": "Waived minimum spend"
    }
  },
  "tastemaker": {
    "readMore": "Read More",
    "readLess": "Read Less"
  },
  "errors": {
    "searchVenuesTitle": "Error Searching Venues",
    "searchVenuesBody": "There was an error searching venues. Please refresh the page or contact support."
  },
  "sections": {
    "recentlyViewed": "Recently viewed"
  },
  "discover": {
    "title": "Discover Venues",
    "subtitle": "Curated collections for every kind of event — from rooftop dinners to all-day offsites.",
    "partnerDeals": {
      "title": "Partner Deals",
      "creditBadge": "Ande Rewards",
      "descriptionWithEndFromToday": "Ande credit available at bookings at the following partner venues. Available until {{date}}. Eligible on bookings from today to {{end}}.",
      "descriptionWithEnd": "Ande credit available at bookings at the following partner venues. Available until {{date}}. Eligible on bookings from {{start}} to {{end}}.",
      "descriptionNoEndFromToday": "Ande credit available at bookings at the following partner venues. Eligible on bookings from today to {{end}}.",
      "descriptionNoEnd": "Ande credit available at bookings at the following partner venues. Eligible on bookings from {{start}} to {{end}}."
    },
    "lists": {
      "newToAnde": {
        "label": "New to Ande",
        "description": "Newest partner venues on the platform."
      },
      "mostBooked": {
        "label": "Most Booked",
        "description": "Most booked on the platform near you."
      },
      "trending": {
        "label": "Trending",
        "description": "Featured in must-try lists from Eater and The Infatuation."
      },
      "bookedByCoworkers": {
        "label": "Recently Booked by Coworkers",
        "description": "Get inspiration from your company's latest bookings."
      },
      "michelinStar": {
        "label": "Michelin Star Restaurants",
        "description": "Where exceptional cuisine, artistry, and impeccable service come together."
      },
      "nearbyVenues": {
        "label": "Nearby Venues",
        "labelNear": "Near {{location}}",
        "description": "Find hidden gems near your workplace."
      },
      "recentlyVisited": {
        "label": "Recently Visited",
        "description": "Recently visited venues near you."
      }
    }
  },
  "browseHeader": {
    "unknownLocation": "Unknown Location",
    "affiliateLogoAlt": "Affiliate Logo"
  },
  "venueCardPanel": {
    "showingAvailable": "Showing Available",
    "showingNotAvailable": "Showing Not Available",
    "sectionTitlePrivateDining": "Private Dining",
    "sectionTitleGeneralDining": "General Dining",
    "headingGeneralDining": "General dining",
    "spaceOptionsAvailable_one": "{{available}} of {{total}} space available",
    "spaceOptionsAvailable_other": "{{available}} of {{total}} spaces available",
    "spaceOptionCount_one": "{{count}} space option",
    "spaceOptionCount_other": "{{count}} space options",
    "viewMoreTimes": "View more times",
    "loadingVenueDetails": "Loading venue details",
    "loadingSpaceOptions": "Loading space options",
    "closeVenueDetails": "Close venue details",
    "venueDetailsUnavailable": "Venue details unavailable",
    "venueSummaryAria": "Venue summary",
    "openFullVenueDetails": "Open full venue details",
    "fullVenueDetails": "Full venue details",
    "venueSectionsAria": "Venue sections",
    "venueActionsAria": "Venue actions",
    "addToFavorites": "Add to favorites",
    "removeFromFavorites": "Remove from favorites",
    "addToShortlistLower": "Add to shortlist",
    "removeFromShortlistLower": "Remove from shortlist",
    "shortlisted": "Shortlisted",
    "inquirySent": "Inquiry sent",
    "alreadyInquiredTooltip": "You've already inquired",
    "headingOtherSpaces": "Other spaces",
    "closed": "Closed",
    "aboutVenue": "About {{name}}",
    "aboutThisVenue": "this venue",
    "andeCommunityReviews": "Ande community reviews",
    "generatedByAndeAi": "Generated by Ande AI",
    "bookedByCoworkersAria_one": "Booked by {{count}} coworker",
    "bookedByCoworkersAria_other": "Booked by {{count}} coworkers",
    "ratingGoogle": "Google",
    "ratingYelp": "Yelp",
    "stickyTabSpaceOptions": "Space options",
    "stickyTabAbout": "About",
    "roomDetailsPrevious": "Previous room",
    "roomDetailsNext": "Next room",
    "roomDetailsClose": "Close room details",
    "roomPhotoAria": "Show room photo {{index}}",
    "availabilityCriteriaTitle": "Add availability criteria",
    "availabilityCriteriaBody": "Set a date, time, and party size in the Browse controls to check availability and booking options.",
    "priceFromPerPerson": "From {{amount}}/pp",
    "priceFromTotal": "From {{amount}} total",
    "restore": "Restore",
    "privateDiningLower": "Private dining",
    "eventAvailabilityNote": "Availability shown is based on your event date unless otherwise noted",
    "showLess": "Show less",
    "viewMoreSpaces_one": "View {{count}} more space",
    "viewMoreSpaces_other": "View {{count}} more spaces",
    "inquireToSeeSpaceOptions": "Inquire to see space options",
    "inquireSpaceOptionsBody": "Ande will reach out to {{venueName}} for room availability, capacity, and pricing tailored to your event.",
    "spacesThatFitYourEvent": "Spaces that fit your event",
    "venueDetailsUnavailableBody": "We couldn't load details for this venue. It may have been removed or the link is invalid.",
    "dismiss": "Dismiss",
    "venueDefaultName": "Venue",
    "messageHistory": "Message history",
    "mapAlt": "Map showing {{venueName}}",
    "mapAriaOpen": "Open {{venueName}} in Google Maps",
    "openInGoogleMaps": "Open in Google Maps",
    "websiteFallback": "Website",
    "sampleMenuLower": "Sample menu",
    "seeAll": "See all",
    "seeAllCount": "See all {{count}}",
    "generalDiningSlotDefault": "Dining",
    "couldntLoadAvailability": "Couldn't load availability",
    "tryAgain": "Try again",
    "roomPaginationPrev": "Prev",
    "roomPaginationNext": "Next",
    "roomPaginationIndex": "Room {{current}} of {{total}}",
    "venueCouldNotBeLoaded": "This venue could not be loaded.",
    "roomAvailable": "Available",
    "priceNotListed": "Price not listed",
    "roomDetailsFallback": "{{roomName}} is one of the event spaces at {{venueName}}. Inquire to confirm availability, capacity, and pricing for your event.",
    "gdCheckAvailability": "Check availability",
    "gdCallToBook": "Call to book",
    "gdEmailToBook": "Email to book",
    "gdViewOnResy": "View on Resy",
    "gdVisitWebsite": "Visit website"
  },
  "venueCard": {
    "automatedReceiptsTitle": "Automated Receipts",
    "automatedReceiptsBody": "No more pictures of receipts! Expenses can be filed immediately after your event concludes.",
    "signedContractTitle": "Signed Contract",
    "signedContractBody": "Your company has already signed a contract with this venue, so approval can be fast-tracked!",
    "andeLine": "Ande Line",
    "generallyAvailableNoFee": "Generally Available (No Fee)",
    "seeNextAvailable": "See Next Available",
    "noAvailabilityForCriteria": "No availability for the selected date, time, & party size",
    "otherSpaces": "Other Spaces",
    "notExactMatch": "(Not an Exact Match)",
    "allTimes": "All Times",
    "poweredBy": "Powered by",
    "review_one": "{{count}} review",
    "review_other": "{{count}} reviews",
    "disqualified": {
      "unavailable": "We disqualified this option because it's <bold>unavailable.</bold>",
      "tooLarge": "We disqualified this option because it's <bold>too large for your party.</bold>",
      "tooSmall": "We disqualified this option because it's <bold>too small for your party.</bold>"
    }
  },
  "venuePage": {
    "notifications": {
      "couldNotSaveTitle": "Could not save",
      "couldNotRemoveTitle": "Could not remove",
      "anErrorOccurredTitle": "An Error Occurred",
      "errorTitle": "Error",
      "eventUpdatedTitle": "Event Updated",
      "eventCreatedTitle": "Event Created",
      "messageSentTitle": "Message sent",
      "alreadySavedTitle": "Already saved",
      "eventSchedulingRequiredTitle": "Event scheduling required",
      "savedToEventTitle": "Saved to event",
      "removedFromEventTitle": "Removed from event",
      "removedFromShortlistTitle": "Removed from shortlist",
      "venueMismatchBody": "Venue mismatch. Please refresh and try again.",
      "eventNotFoundBody": "We could not find that event.",
      "eventArchivedBody": "This event is archived.",
      "eventAccessDeniedBody": "You do not have access to this event.",
      "somethingWentWrongBody": "Something went wrong. Please try again.",
      "timeslotAddedBody": "Timeslot added to event successfully.",
      "eventCreatedBody": "Your event has been created successfully.",
      "messageSentBody": "Your message has been successfully sent to the venue",
      "inquiryCreateFailedBody": "We were unable to create your venue inquiry. Please try again later",
      "checkEventSelectionBody": "Please check your event selection and try again.",
      "venueHasBookingBody": "This venue has a booking on your event and cannot be removed from your plan.",
      "inquiryOpenRemoveBlockedBody": "You cannot remove this venue from your event while an inquiry is open. Continue from your event plan or messages.",
      "venueRemovedFromPlanBody": "This venue is no longer on your event plan.",
      "spaceRemovedFromPlanBody": "This space is no longer on your event plan for this venue.",
      "tryAgainRemoveBody": "Please try again.",
      "optionRemovedFromPlanBody": "This option was removed from your event plan.",
      "invalidExperienceBody": "Invalid experience data. Please try again.",
      "venueAlreadyOnEventBody": "This venue is already on your event.",
      "spaceAlreadyOnEventBody": "This space is already on your event.",
      "eventSchedulingRequiredBody": "Add a date, time, and guest count to this event before saving a space.",
      "savedToEventBody": "You can review it anytime from your event plan.",
      "timeslotRemovedBody": "Timeslot removed from event",
      "reservationDeleteFailedBody": "We were unable to delete your reservation. Please try again later",
      "failedCreateReservationBody": "Failed to create reservation. {{details}}",
      "deferredDetailsFailedBody": "An error occurred fetching venue deferred details. Please try again later.",
      "venueInactiveBody": "Venue is not active at this time. Please try again later.",
      "venueNotFoundBody": "Venue not found",
      "venueUnavailableForDiningMessage": "Venue unavailable for dining",
      "eventUpdateErrorBody": "There was an error updating the event. {{details}}",
      "eventCreateErrorBody": "There was an error creating the event. {{details}}"
    },
    "errorBoundary": {
      "title": "Venue not found",
      "body": "The venue you are looking for does not exist, has been removed, or is not available.",
      "browseVenues": "Browse venues",
      "askAiAssistant": "Ask AI Assistant"
    },
    "header": {
      "showMoreImagesAria": "Show more images"
    },
    "mainDiningEmpty": {
      "iconAlt": "Main Dining Empty Card Icon",
      "notListingBody": "{{venueName}} isn't listing regular reservations on Ande yet.",
      "checkWebsite": "Check their website"
    },
    "privateDiningEmpty": {
      "sectionHeading": "Private & Semi-Private Rooms",
      "iconAlt": "Empty Card Icon",
      "notListingBody": "{{venueName}} isn't listing spaces on Ande yet.",
      "conciergeBody": "No problem - Our Virtual Concierge can reach out and get the details for you.",
      "startInquiryButton": "Start Inquiry with {{venueName}}"
    },
    "awardsSection": {
      "titleAwardsAndPublications": "Awards & Publications",
      "titleAwards": "Awards",
      "titlePublications": "Publications",
      "featuredIn": "Featured in",
      "publicationPreviewAlt": "preview",
      "publicationTitleFallback": "Title",
      "yearFallback": "Year"
    },
    "characteristics": {
      "cocktailsTitle": "Cocktails & Light Bites",
      "cocktailsPopup": "This venue is great for happy hour or after-work events",
      "dietaryTitle": "Supports Dietary Restrictions",
      "dietaryPopup": "This venue can accommodate dietary restrictions",
      "outdoorTitle": "Outdoor Dining",
      "outdoorPopup": "Offers outdoor seating options",
      "rooftopTitle": "Rooftop",
      "rooftopPopup": "Features a rooftop dining area",
      "livelyTitle": "Lively",
      "livelyPopup": "High-energy atmosphere",
      "quietTitle": "Quiet",
      "quietPopup": "Intimate, quiet setting",
      "automatedExpensesTitle": "Automated Expenses",
      "automatedExpensesPopup": "No more pictures of receipts! Expenses can be filed immediately after your event concludes"
    },
    "regularReservation": {
      "title": "Regular Reservation",
      "startingPricePp": "Starting {{price}}pp",
      "nothingAvailable": "Nothing available for this date & time."
    },
    "coworkerAvatars": {
      "bookedBy_one": "Booked by {{count}} coworker",
      "bookedBy_other": "Booked by {{count}} coworkers",
      "bookedByMax": "Booked by 10+ coworkers",
      "tooltipSingle": "{{name}} has booked here!",
      "tooltipMultiple": "{{names}} have booked here!",
      "tooltipWithOthersCount_one": "{{names}} and {{count}} other have booked here!",
      "tooltipWithOthersCount_other": "{{names}} and {{count}} others have booked here!"
    },
    "reviews": {
      "reviewsFromMembersCount_one": "{{count}} Review from an Ande member",
      "reviewsFromMembersCount_other": "{{count}} Reviews from Ande members"
    },
    "inquiry": {
      "defaultLeadNote": "Hi, I'm interested in booking an event at this venue.",
      "sendInquiryTitle": "Send an inquiry",
      "messageVenueTitle": "Message {{venueName}}",
      "sendInquiryToVenue": "Send Inquiry to {{venueName}}",
      "sending": "Sending...",
      "addToEventLabel": "Add to an Event",
      "eventNameLabel": "Event Name",
      "startTimeLabel": "Start Time",
      "selectSpaceType": "Select a space type:",
      "spaceTypeAria": "Space type selection",
      "spaceTypeLargeTable": "Large Table",
      "spaceTypeSemiPrivate": "Semi-Private",
      "spaceTypeFullyPrivate": "Fully Private",
      "selectSpacesInterested": "Select the spaces you're interested in",
      "noteLabelAdditional": "Any additional information you'd like to add?",
      "noteLabelLegacy": "Enter your note below -- it's delivered straight to the venue. You'll get their direct response via email.",
      "venueImageAlt": "Venue",
      "yourInquiryHeading": "Your Inquiry:",
      "partyOf": "Party of {{count}}",
      "cancel": "Cancel",
      "send": "Send",
      "inquirySentTitle": "Inquiry Sent",
      "inquirySentFollowUp": "They’ll reach out soon via messaging to review details and confirm availability.",
      "keepBrowsing": "Keep browsing options",
      "viewInquiry": "View Inquiry",
      "noteMaxLength": "Note for the venue must be less than 500 characters",
      "eventNameRequired": "Event name is required",
      "selectSpacesInterestedWithCount_one": "Select the spaces you're interested in ({{count}} selected)",
      "selectSpacesInterestedWithCount_other": "Select the spaces you're interested in ({{count}} selected)",
      "inquirySharedWithVenue": "Your request has been shared with <bold>{{venueName}}</bold>."
    },
    "pdrSection": {
      "showMoreHidden_one": "Show {{count}} More",
      "showMoreHidden_other": "Show {{count}} More",
      "showMoreHiddenWithoutAvailability_one": "Show {{count}} More without availability",
      "showMoreHiddenWithoutAvailability_other": "Show {{count}} More without availability",
      "showLessWithoutAvailability": "Show less without availability"
    },
    "pdrCard": {
      "outOfBudgetRisk": "Out of Budget Risk",
      "exceedsCapacity": "Exceeds capacity. Inquire to confirm.",
      "limitedInDemand": "Showing Available (In demand)",
      "availableOnRequest": "Available on Request",
      "partySizeMin": "Not available for your party size. Minimum is {{count}} guests.",
      "partySizeMax": "Not available for your party size. Maximum is {{count}} guests.",
      "showMore": "Show More"
    },
    "details": {
      "tierLabel": "{{tier}} Tier",
      "checkAvailabilityLabel": "Check Availability:",
      "budgetAny": "Any",
      "andeLine": "Ande Line",
      "gettingStarted": "Getting Started",
      "confirmAndPay": "Confirm and Pay",
      "messageVenueAlt": "Message Venue",
      "aboutVenue": "About {{name}}",
      "nearby": "Nearby",
      "office": "Office",
      "ratings": "Ratings",
      "tastemakerReviews": "Tastemaker Reviews",
      "communityReviews": "Community Reviews",
      "youMightAlsoLike": "You might also like",
      "instantlyBookSpace": "Instantly Book a Space",
      "createNewEvent": "Create a new event",
      "yourDraftEvents": "Your draft events",
      "closed": "closed",
      "parking": "Parking",
      "otherDiningOptions": "Other Dining Options",
      "openingHours": "Opening hours",
      "accessibility": "Accessibility",
      "website": "Website",
      "phone": "Phone",
      "directions": "Directions",
      "messageVenue": "Message Venue",
      "budgetUsd": "Budget (USD)",
      "budgetAfterTaxesFees": "After taxes, fees & gratuity.",
      "policyWarningTitle": "Policy Warning",
      "policyWarningBody": "At this venue the starting cost is above your spend limit.",
      "outOfBudgetRiskBody": "At this venue the starting cost is above your indicated budget.",
      "updatingAvailability": "Updating availability…",
      "addedToShortlist": "Added to Shortlist",
      "removeFromShortlist": "Remove from Shortlist",
      "generallyAvailableNoFee": "Generally Available (No Fee)",
      "requestAndeLine": "Request Ande Line",
      "gettingStartedStep1": "Add to your <shortlist>Event's Shortlist</shortlist>",
      "gettingStartedStep2": "Send inquiries to your shortlist options",
      "gettingStartedStep3": "Work out the details and contract",
      "allTimes": "All Times",
      "questionsFor": "Questions for {{venueName}}?",
      "dietaryPrompt": "Ask about dietary accommodations, table options, communicate any special requests or request more information.",
      "reviewsFromMembers_one": "{{count}} Review from an Ande Member",
      "reviewsFromMembers_other": "{{count}} Reviews from Ande Members",
      "reviewNoun_one": "review",
      "reviewNoun_other": "reviews",
      "seeMore": "See More",
      "listsThatMention": "Lists that mention {{venueName}}",
      "similarTo": "Similar to {{venueName}}",
      "startingPricePerPerson": "Starting {{amount}} pp"
    },
    "shortlistAria": {
      "remove": "Remove venue from shortlist",
      "save": "Save venue to your event",
      "choose": "Choose an event to save this venue"
    },
    "selectTime": "Select time",
    "andeBookingRequest": {
      "titleSubmitInquiry": "Submit inquiry",
      "venueSection": "Venue",
      "roomSection": "Room",
      "roomsSection": "Rooms",
      "spacesSelected_one": "{{count}} space selected",
      "spacesSelected_other": "{{count}} spaces selected",
      "inquiryMessageShortlist": "Inquiry message",
      "selectRoomsInterested": "Select rooms you're interested in",
      "selectedCount": "({{count}} selected)",
      "seated": "{{count}} seated",
      "standing": "{{count}} standing",
      "startingPrice": "Starting {{price}}",
      "paymentAgreement": "By submitting this request, you agree to pay all restaurant fees and the non-refundable {{feePercent}}% booking fee if your booking is accepted by the venue.",
      "paymentAgreementNoCharge": "You will not be charged until a contract is signed.",
      "approvalBypassed": "Approval Bypassed - No approver available",
      "editEvent": "Edit"
    },
    "vipRequest": {
      "title": "Ande Line request",
      "guestsOnDate_one": "{{count}} guest on {{dateTime}}",
      "guestsOnDate_other": "{{count}} guests on {{dateTime}}",
      "minSpendLabel": "Minimum spend you are willing to commit (optional)",
      "minSpendHint": "Leave blank and we will confirm the venue's minimum spend with you once it comes in.",
      "paymentCard": "Payment card",
      "addCardFirst": "Add a card to your account before submitting an Ande Line request.",
      "notesLabel": "Notes for the venue",
      "notesPlaceholder": "Share any seating preferences, timing flexibility, or occasion details.",
      "feeAgreement": "I agree that Ande may charge the {{fee}} Ande Line booking fee only if this request is confirmed by the venue.",
      "submit": "Submit Ande Line request",
      "bookingFor": "Booking for",
      "searchExecutivesPlaceholder": "Search executives by name or email",
      "searchingExecutives": "Searching executives…",
      "noExecutivesMatch": "No executives with full VIP access match this search.",
      "executivePaymentDisclaimer": "Your payment card will be used. The selected executive will be introduced to the venue as the guest.",
      "venueTermsIntro": "By confirming, you accept the following terms and conditions from the venue:"
    },
    "bookmarkEventPicker": {
      "addDraftEventHint": "Add a draft event to your plan, then we'll save this bookmark to it.",
      "chooseDraftEventHint": "Choose a draft event to add this bookmark to. You can change it later from your event plan.",
      "createNewEvent": "Create new event",
      "browseToPlanHint": "Or browse to plan from search. You can also manage events from your account.",
      "browseDiningLink": "Browse dining and plan an event",
      "viewYourEventsLink": "View your events"
    },
    "inquiryEventPicker": {
      "label": "Select an event",
      "placeholder": "Choose from your events",
      "createNewEvent": "Create new event",
      "guestCount_one": "{{count}} guest",
      "guestCount_other": "{{count}} guests",
      "duplicateWarning": "You have an existing event called <bold>{{eventName}}</bold> on {{date}}. If this is the same event, select it so you don't end up with duplicates.",
      "duplicateWarningWithGuests_one": "You have an existing event called <bold>{{eventName}}</bold> on {{date}} for {{count}} guest. If this is the same event, select it so you don't end up with duplicates.",
      "duplicateWarningWithGuests_other": "You have an existing event called <bold>{{eventName}}</bold> on {{date}} for {{count}} guests. If this is the same event, select it so you don't end up with duplicates.",
      "selectDuplicateEvent": "Select {{eventName}}",
      "eventName": "Event name",
      "venue": "Venue",
      "date": "Date",
      "guests": "Guests",
      "eventTypeAria": "Event type",
      "eventTypePlaceholder": "Event Type",
      "totalBudget": "Total budget"
    },
    "inquiryRoomGrid": {
      "noAvailableSpaces": "No spaces with availability",
      "unavailable": "Unavailable"
    },
    "sendInquiryButton": {
      "sendInquiry": "Send Inquiry",
      "sendInquiries": "Send Inquiries"
    }
  }
}
